import React from 'react';

import PropTypes from 'prop-types';
import Box from '@tds/core-box';
import Heading from '@tds/core-heading';

import {
  Thead,
  Td,
  Tr,
  Th
} from '../orderDetailsSection/ratePlans/components/css';

const SummaryRatePlanRenewal = ({ renewalSubscriberList }) => {
  return (
    <>
      {renewalSubscriberList.length === 0 && <h4>No renewal info found</h4>}
      {renewalSubscriberList.length > 0 && (
        <Box between={3}>
          <Heading level="h4">Rateplan Renewal Info</Heading>
          <table>
            <Thead>
              <Tr>
                <Th>#</Th>
                <Th>Subscriber</Th>
                <Th>Plan</Th>
                <Th>Device</Th>
                <Th>Term</Th>
                <Th>Price</Th>
                <Th>Offer</Th>
                <Th>VIN</Th>
                <Th>Make</Th>
                <Th>Model</Th>
                <Th>Year</Th>
              </Tr>
            </Thead>
            <tbody>
              {renewalSubscriberList.map((details, index) => {
                const {
                  subscriber,
                  plan,
                  device,
                  term,
                  price,
                  offer,
                  vin,
                  make,
                  model,
                  year
                } = details;
                return (
                  <tr>
                    <Td>{index + 1}</Td>
                    <Td>{subscriber}</Td>
                    <Td>{plan}</Td>
                    <Td>{device}</Td>
                    <Td>{term}</Td>
                    <Td>{price}</Td>
                    <Td>{offer}</Td>
                    <Td style={{ background: vin ? '#fff' : '#f4f4f4' }}>
                      {vin}
                    </Td>
                    <Td style={{ background: make ? '#fff' : '#f4f4f4' }}>
                      {make}
                    </Td>
                    <Td style={{ background: model ? '#fff' : '#f4f4f4' }}>
                      {model}
                    </Td>
                    <Td style={{ background: year ? '#fff' : '#f4f4f4' }}>
                      {year}
                    </Td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Box>
      )}
    </>
  );
};

SummaryRatePlanRenewal.propTypes = {
  renewalSubscriberList: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

export default SummaryRatePlanRenewal;
